<template>
    <b-card
        v-if="sourceMissionFamily.code !== 'SOC'"
        :title="sourceMissionFamily.name"
        class="shadow-sm mb-3"
    >
        <mission-handler
            v-for="mission in missions"
            :key="'sm' + mission.source_mission_id + key"
            :mission="mission"
            :client-id="clientId"
            @mission-has-changed="getMissions"
        />
    </b-card>
</template>

<script>
import MissionHandler from './MissionHandler.vue'
import KeyHandler from "../../../invoicing/mixins/KeyHandler.vue";

export default {
    name: 'MissionFamilyCard',

    components: {
        MissionHandler,
    },

    mixins: [KeyHandler],

    props: {
        sourceMissionFamily: {
            required: true,
            type: Object,
        },
        clientId: {
            required: true,
            type: Number,
        },
    },

    data() {
        return {
            missions: [],
        }
    },

    async created() {
        await this.getMissions()
    },

    methods: {
        async getMissions() {
            try {
                const response = await this.$axios.get(
                    `clients/${this.clientId}/sourceMissionFamilies/${this.sourceMissionFamily.id}`
                )
                this.missions = response.data.data
                this.updateKey()
            } catch (error) {
                //
            }
        },
    },
}
</script>

<style scoped></style>
